

/* ===========================================
   LOADING
=========================================== */

import { alertActions } from "../../screens/tenants/redux/alert.actions"
import { showSuccesToast } from "../../screens/tenants/tenantOnboarding/helpers"
import { maintenanceConstants } from "../reducers/maintenance.constants"
import { maintenanceService } from "./maintenance.service"

const setLoading = (value: boolean) => ({
  type: maintenanceConstants.SET_LOADING,
  payload: value,
})

/* ===========================================
   GET ROOM TYPES
=========================================== */

export function getRoomTypes() {
  return async (dispatch: any) => {
    dispatch(setLoading(true))
    dispatch({ type: maintenanceConstants.GET_ROOM_TYPES_REQUEST })

    try {
      const data = await maintenanceService.getRoomTypes()

      if (data.status) {
        dispatch({
          type: maintenanceConstants.GET_ROOM_TYPES_SUCCESS,
          data: data.data,
        })
      } else {
        dispatch({
          type: maintenanceConstants.GET_ROOM_TYPES_FAILURE,
          error: data.message,
        })
        dispatch(alertActions.error(data.message))
      }
    } catch (error) {
      dispatch({
        type: maintenanceConstants.GET_ROOM_TYPES_FAILURE,
        error,
      })
      dispatch(alertActions.error("Failed to get room types"))
    }

    dispatch(setLoading(false))
  }
}
export function getCatogoriesTypes() {
    return async (dispatch: any) => {
      dispatch(setLoading(true))
      dispatch({ type: maintenanceConstants.GET_CATEGORY_TYPES_REQUEST })
  
      try {
        const data = await maintenanceService.getCatogoriesTypes()
  
        if (data.status) {
          dispatch({
            type: maintenanceConstants.GET_CATEGORY_TYPES_SUCCESS,
            data: data.data,
          })
        } else {
          dispatch({
            type: maintenanceConstants.GET_CATEGORY_TYPES_FAILURE,
            error: data.message,
          })
          dispatch(alertActions.error(data.message))
        }
      } catch (error) {
        dispatch({
          type: maintenanceConstants.GET_CATEGORY_TYPES_FAILURE,
          error,
        })
        dispatch(alertActions.error("Failed to get cat types"))
      }
  
      dispatch(setLoading(false))
    }
  }
/* ===========================================
   GET FLOWS
=========================================== */

export function getFlow(params: any = {}) {
  return async (dispatch: any) => {
  console.log("params",params)
    dispatch(setLoading(true))
    dispatch({ type: maintenanceConstants.GET_FLOWS_REQUEST })

    const defaultParams = {
      limit: params.limit || 17,
      offset: params?.offset || 0,
      sortOrder: params.sortOrder || "DESC",
      search: params.search || "",
      "flow_id":params.flow_id
    }

    try {
      const data = await maintenanceService.getFlows(defaultParams)

      if (data.status) {
        if(params?.flow_id){
          dispatch({
            type: maintenanceConstants.GET_ISSUES_SUCCESS,
            data: {
              data: data.data?.data || [],
              count: data.data?.count || 0,
            },
          })
        }else{
          dispatch({
            type: maintenanceConstants.GET_FLOWS_SUCCESS,
            data: {
              data: data.data?.data || [],
              count: data.data?.count || 0,
            },
          })
        }

      } else {
        dispatch({
          type: maintenanceConstants.GET_FLOWS_FAILURE,
          error: data.message,
        })
        dispatch(alertActions.error(data.message))
      }
    } catch (error) {
      dispatch({
        type: maintenanceConstants.GET_FLOWS_FAILURE,
        error,
      })
      dispatch(alertActions.error("Failed to fetch flows"))
    }

    dispatch(setLoading(false))
  }
}

/* ===========================================
   ADD ISSUE
=========================================== */

export function addIssue(payload: any,cb:any) {
  return async (dispatch: any) => {
    dispatch(setLoading(true))
    dispatch({ type: maintenanceConstants.ADD_ISSUE_REQUEST })

    try {
      const data = await maintenanceService.addIssue(payload)
      cb(data)
      if (data.status) {
        dispatch({
          type: maintenanceConstants.ADD_ISSUE_SUCCESS,
          data,
        })
      } else {
        dispatch({
          type: maintenanceConstants.ADD_ISSUE_FAILURE,
          error: data.message,
        })
        dispatch(alertActions.error(data.message))
      }
    } catch (error) {
      dispatch({
        type: maintenanceConstants.ADD_ISSUE_FAILURE,
        error,
      })
      dispatch(alertActions.error("Failed to create issue"))
    }

    dispatch(setLoading(false))
  }
}
export function editIssue(payload: any,cb:any) {
  return async (dispatch: any) => {
    dispatch(setLoading(true))
    dispatch({ type: maintenanceConstants.ADD_ISSUE_REQUEST })

    try {
      const data = await maintenanceService.editIssue(payload)
      cb(data)
      if (data.status) {
        dispatch({
          type: maintenanceConstants.ADD_ISSUE_SUCCESS,
          data,
        })
      } else {
        dispatch({
          type: maintenanceConstants.ADD_ISSUE_FAILURE,
          error: data.message,
        })
        dispatch(alertActions.error(data.message))
      }
    } catch (error) {
      dispatch({
        type: maintenanceConstants.ADD_ISSUE_FAILURE,
        error,
      })
      dispatch(alertActions.error("Failed to create issue"))
    }

    dispatch(setLoading(false))
  }
}
/* ===========================================
   UPDATE ISSUE
=========================================== */

export function updateIssue(payload: any) {
  return async (dispatch: any) => {
    dispatch(setLoading(true))
    dispatch({ type: maintenanceConstants.UPDATE_ISSUE_REQUEST })

    try {
      const data = await maintenanceService.updateIssue(payload)

      if (data.status) {
        dispatch({
          type: maintenanceConstants.UPDATE_ISSUE_SUCCESS,
          data,
        })
        dispatch(getIssue({}))
      } else {
        dispatch({
          type: maintenanceConstants.UPDATE_ISSUE_FAILURE,
          error: data.message,
        })
        dispatch(alertActions.error(data.message))
      }
    } catch (error) {
      dispatch({
        type: maintenanceConstants.UPDATE_ISSUE_FAILURE,
        error,
      })
      dispatch(alertActions.error("Failed to update issue"))
    }

    dispatch(setLoading(false))
  }
}

/* ===========================================
   GET ISSUES
=========================================== */

export function getIssue(params: any = {}) {
  return async (dispatch: any) => {
    dispatch(setLoading(true))
    dispatch({ type: maintenanceConstants.GET_ISSUES_REQUEST })

    try {
      const data = await maintenanceService.getIssues(params)

      if (data.status) {
        dispatch({
          type: maintenanceConstants.GET_ISSUES_SUCCESS,
          data: {
            data: data.data?.data || [],
            count: data.data?.count || 0,
          },
        })
      } else {
        dispatch({
          type: maintenanceConstants.GET_ISSUES_FAILURE,
          error: data.message,
        })
        dispatch(alertActions.error(data.message))
      }
    } catch (error) {
      dispatch({
        type: maintenanceConstants.GET_ISSUES_FAILURE,
        error,
      })
      dispatch(alertActions.error("Failed to fetch issues"))
    }

    dispatch(setLoading(false))
  }
}

export function getProjects(params: any = {}) {
  return async (dispatch: any) => {
    try {
      dispatch(setLoading(true))
      dispatch({ type: maintenanceConstants.GET_PROJECTS_REQUEST })

      const defaultParams = {
        limit: params.limit || 100,
        offset: params.offset || 0,
        sortOrder: params.sortOrder || "DESC",
        search: params.search || "",
        status: params.type=="completed"?"completed": params.type=="archived"?"archived":"inprogress",
      }

      if (params.flow_id) {
        defaultParams.flow_id = params.flow_id
      }

      const data = await maintenanceService.getProjects(defaultParams)

      if (data.status) {
        const projects = data.data?.data || []
        const count = data.data?.count || 0
        if(params?.flow_id)
          dispatch({
            type: maintenanceConstants.GET_PROJECTS_I_SUCCESS,
            data: { data: data.data },
          })
        else
        dispatch({
          type: maintenanceConstants.GET_PROJECTS_SUCCESS,
          data: { data: projects, count },
        })

        return { data: projects, count }
      } else {
        // if(params?.flow_id)
        //   dispatch({
        //     type: maintenanceConstants.GET_PROJECTS_I_FAILURE,
        //     error: data.message,
        //   })
        // else
        dispatch({
          type: maintenanceConstants.GET_PROJECTS_FAILURE,
          error: data.message,
        })
        dispatch(alertActions.error(data.message))
        throw new Error(data.message)
      }
    } catch (error) {
      // if(params?.flow_id)
      //   dispatch({
      //     type: maintenanceConstants.GET_PROJECTS_I_FAILURE,
      //     error:error
      //   })
      // else
      dispatch({
        type: maintenanceConstants.GET_PROJECTS_FAILURE,
        error,
      })
      dispatch(alertActions.error("Failed to fetch projects"))
      throw error
    } finally {
      dispatch(setLoading(false))
    }
  }
}
export function getProjectsCompleted(params: any = {}) {
  return async (dispatch: any) => {
    try {
      dispatch(setLoading(true))
      dispatch({ type: maintenanceConstants.GET_PROJECTS_COMPLETED_REQUEST })

      const defaultParams = {
        limit: params.limit || 100,
        offset: params.offset || 0,
        sortOrder: params.sortOrder || "DESC",
        search: params.search || "",
        status: "completed",
      }

      if (params.flow_id) {
        defaultParams.flow_id = params.flow_id
      }

      const data = await maintenanceService.getProjects(defaultParams)

      if (data.status) {
        dispatch(getProjects())
        const projects = data.data?.data || []
        const count = data.data?.count || 0

        dispatch({
          type: maintenanceConstants.GET_PROJECTS_COMPLETED_SUCCESS,
          data: { data: projects, count },
        })

        return { data: projects, count }
      } else {
        dispatch({
          type: maintenanceConstants.GET_PROJECTS_COMPLETED_FAILURE,
          error: data.message,
        })
        dispatch(alertActions.error(data.message))
        throw new Error(data.message)
      }
    } catch (error) {
      dispatch({
        type: maintenanceConstants.GET_PROJECTS_COMPLETED_FAILURE,
        error,
      })
      dispatch(alertActions.error("Failed to fetch projects"))
      throw error
    } finally {
      dispatch(setLoading(false))
    }
  }
}


export function updateIssueStatus(params: any = {}) {
  return async (dispatch: any) => {
    try {
      dispatch(setLoading(true))

      const data = await maintenanceService.updateIssueStatus(params)

      if (data.status) {
        dispatch(getProjects({flow_id:params.project_id}))
      } else {
     
      }
    } catch (error) {
      dispatch({
        type: maintenanceConstants.GET_PROJECTS_COMPLETED_FAILURE,
        error,
      })
      dispatch(alertActions.error("Failed to fetch projects"))
      throw error
    } finally {
      dispatch(setLoading(false))
    }
  }
}
export function updateProject(params: any = {},cb:any) {
  return async (dispatch: any) => {
    try {
      dispatch(setLoading(true))

      const data = await maintenanceService.updateProject(params)

      if (data.status) {
        cb(data)
        dispatch(getProjects({flow_id:params.project_id}))
      } else {
     
      }
    } catch (error) {
      dispatch({
        type: maintenanceConstants.GET_PROJECTS_COMPLETED_FAILURE,
        error,
      })
      dispatch(alertActions.error("Failed to fetch projects"))
      throw error
    } finally {
      dispatch(setLoading(false))
    }
  }
}
export function archiveProject(params: any = {},type) {
  return async (dispatch: any) => {
    try {
      dispatch(setLoading(true))

      const data = await maintenanceService.archiveProject(params)

      if (data.status) {
        showSuccesToast("projects archived successfully!")

        dispatch(getProjects({
          type:type,
          limit:100,
          offset:0,
          sortOrder:"DESC"
        }))
      } else {
     
      }
    } catch (error) {
      dispatch({
        type: maintenanceConstants.GET_PROJECTS_COMPLETED_FAILURE,
        error,
      })
      dispatch(alertActions.error("Failed to fetch projects"))
      throw error
    } finally {
      dispatch(setLoading(false))
    }
  }
}
export function unarchiveProject(params: any = {},type) {
  return async (dispatch: any) => {
    try {
      dispatch(setLoading(true))

      const data = await maintenanceService.unarchiveProject(params)

      if (data.status) {
        showSuccesToast("Projects unarchived successfully!")

        dispatch(getProjects({
          type:type,
          limit:100,
          offset:0,
          sortOrder:"DESC"
        }))
      } else {
     
      }
    } catch (error) {
      dispatch({
        type: maintenanceConstants.GET_PROJECTS_COMPLETED_FAILURE,
        error,
      })
      dispatch(alertActions.error("Failed to fetch projects"))
      throw error
    } finally {
      dispatch(setLoading(false))
    }
  }
}